import { useState } from 'react'

import { ReactNode } from 'react'
import Header from '../Admin/Header'
import { ToastContainer } from 'react-toastify'
import UserSidebar from '../User/UserSidebar'

export default function UserLayout({ children }: { children: ReactNode }) {
  const [isMobileOpen, setIsMobileOpen] = useState(false)

  return (
    <div className="min-h-screen flex">
      <ToastContainer />
      <UserSidebar isMobileOpen={isMobileOpen} setIsMobileOpen={setIsMobileOpen} />
      <div className="flex-1 flex flex-col">
        <Header toggleMobileSidebar={() => setIsMobileOpen(!isMobileOpen)} />
        <main className="flex-1 text-gray-900 dark:text-gray-100">
          {children}
        </main>
      </div>
    </div>
  )
}

